module.exports = __webpack_public_path__ + "static/media/i3-map.6ff6ec01.png";